/* eslint-disable */
import watch from 'redux-watch';
import isObjEqual from 'lodash/isEqual';
import ggOrder from './modules/order';
import ggAddress from './modules/address';
import ggPayment from './modules/payment';
import ggBraintree from './modules/braintree';
import ggFilter from './modules/filter';
import ggProduct from './modules/product';

export const checkoutOrder = (store) =>
    watcher(store, ggOrder.selectors.orderActive, (order, oldOrder) => {
        if (order.id !== oldOrder.id && !!order.id) {
            store.dispatch(ggBraintree.actions.authorize(order.number));
        }

        if (order.id) {
            !!order.shipping_address_id &&
                store.dispatch(
                    ggAddress.actions.setActiveAddress(
                        order.shipping_address_id,
                        ggAddress.constants.SHIPPING_NAME,
                    ),
                );
            !!order.billing_address_id &&
                store.dispatch(
                    ggAddress.actions.setActiveAddress(
                        order.billing_address_id,
                        ggAddress.constants.BILLING_NAME,
                    ),
                );
            !!order.current_payment_source_id &&
                store.dispatch(
                    ggPayment.actions.setActiveUserPaymentMethodId(order.current_payment_source_id),
                );
        }
    });

export const filter = (store, customFilter = {}) =>
    watcher(store, ggFilter.selectors.activeJson, (filter, oldFilter) => {
        if (!isObjEqual(filter, oldFilter)) {
            store.dispatch(ggProduct.actions.getProductsByFilter(customFilter));
            store.dispatch(ggFilter.actions.getListOfFilters(customFilter));
        }
    });

function watcher(store, selector, action) {
    let w = watch(() => selector(store.getState()), isObjEqual);
    let unsubscribe = store.subscribe(w(action));

    return unsubscribe;
}
